module.exports = __webpack_public_path__ + "biao6.jpg?dfc7ede";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/biao/biao6.jpg
 ** module id = 61
 ** module chunks = 0
 **/